var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length
    ? _c(
        "segment",
        { staticClass: "actor-highlights", attrs: { title: _vm.title } },
        [
          _c("slick-slides", {
            ref: "SlickSlides",
            staticClass: "actor-slides",
            attrs: {
              options: _vm.slickOptions || _vm.slickOptions2,
              items: _vm.items,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slide-card",
                  fn: function (slotScope) {
                    return [
                      slotScope.item
                        ? _c(
                            "div",
                            { staticClass: "columns" },
                            [
                              _c("actor-card", {
                                staticClass: "column is-6",
                                attrs: {
                                  item: slotScope.item,
                                  "image-as-background": true,
                                },
                              }),
                              _vm.showBody &&
                              slotScope.item.BodyHtml &&
                              slotScope.item.BodyHtml.length
                                ? _c(
                                    "div",
                                    { staticClass: "actor-body column is-6" },
                                    [
                                      _c("article", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            slotScope.item.BodyHtml
                                          ),
                                        },
                                      }),
                                      slotScope.item.BodyHtml &&
                                      slotScope.item.BodyHtml.length > 50
                                        ? _c(
                                            "button",
                                            { staticClass: "btn" },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: _vm.getRoute(
                                                      slotScope.item,
                                                      {
                                                        section:
                                                          "info-artworks",
                                                      },
                                                      "Actor"
                                                    ),
                                                    title: slotScope.item.Name,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.readMore")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showArtworks && slotScope.item.CoverImageInfo
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "actor-body-artworks column",
                                      class:
                                        slotScope.item.CoverImageInfo.Width >
                                        slotScope.item.CoverImageInfo.Height
                                          ? "is-12"
                                          : "is-6",
                                    },
                                    [
                                      _c("artwork-card", {
                                        attrs: {
                                          item: slotScope.item,
                                          resolution: { x: 500 },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._t("default"),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }